import { lazy } from 'react';

export const CreateShiftsPage = lazy(() => import('./CreateShiftsPage'));
